import {
    type ITicketDistributionStatus,
    TicketDistributionStatus,
} from '@/app/modules/seating/guestOperations/Picker/domain/enums/TicketDistributionStatus';

interface Ticket {
    distribution_status: ITicketDistributionStatus;
}

export const isTicketDistributed = (ticket: Ticket) =>
    ticket.distribution_status === TicketDistributionStatus.DISTRIBUTED;

export const isTicketReadyForDistribution = (ticket: Ticket) =>
    ticket.distribution_status === TicketDistributionStatus.TO_DISTRIBUTE;

export const isTicketCancelled = (ticket: Ticket) =>
    ticket.distribution_status === TicketDistributionStatus.CANCELLED;

export const isDistributingTicket = (ticket: Ticket) =>
    ticket.distribution_status === TicketDistributionStatus.DISTRIBUTING;

export const isCancellingTicket = (ticket: Ticket) =>
    ticket.distribution_status === TicketDistributionStatus.CANCELLING;

export const isTicketDistributedOrBeingDistributed = (ticket: Ticket) =>
    ticket.distribution_status === TicketDistributionStatus.DISTRIBUTING ||
    ticket.distribution_status === TicketDistributionStatus.DISTRIBUTED;

export const isTicketMismatched = (ticket: { mismatch: boolean }) => ticket.mismatch;

export const canDistributeTournamentAppTicket = (
    ticket: Ticket,
    guest: {
        has_secutix_contact_number: boolean;
    }
): boolean => {
    return isTicketReadyForDistribution(ticket) && guest.has_secutix_contact_number;
};
